<template>
  <gg-card height="100%">
    <gg-card-header>
      Self Resolve
    </gg-card-header>
    <gg-card-text>
      <ol>
        <li v-for="(step, key) in steps" :key="`step-${key}`">
          {{ step }}
        </li>
      </ol>
    </gg-card-text>
  </gg-card>
</template>

<script>
export default {
  name: 'SelfResolve',
  props: {
    steps: {
      type: Array,
      required: true
    }
  }
}
</script>
